import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFavoriteBorder = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFavoriteBorder",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-147q-14 0-28-5t-26-16l-69-63q-106-97-191-192T80-634q0-94 63-157t157-63q53 0 100 23t80 61q33-39 80-61t100-23q94 0 157 63t63 157q0 115-85 211T602-230l-68 62q-11 11-25 16t-29 5m-38-543q-29-41-62-62t-80-22q-60 0-100 40t-40 100q0 52 37 111t89 113 106 103 88 79l89-79q55-48 106-103t88-113 37-111q0-60-40-100t-100-40q-47 0-80 22t-62 62q-7 10-17 15t-21 5-21-5-17-15m38 189"
  })
}));
IconFavoriteBorder.displayName = 'IconFavoriteBorder';